import React, { useEffect, useState } from 'react';
import styles from './NotificationCard.module.css';
import { HiBell, HiUserGroup, HiChatBubbleBottomCenterText, HiCurrencyDollar, HiExclamationTriangle, HiXMark } from 'react-icons/hi2';
import { useAuth } from "../../utils/AuthContext/authcontext";
import { useTranslation } from 'react-i18next';
import Button from '../ui/Button';

export default function NotificationCard({ notification }) {
  const { user,  markAllNotificationsAsRead, markNotificationAsRead, deleteNotification } = useAuth();
   const { t } = useTranslation();
   const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    setIsDeleting(true);
    setTimeout(async () => {
      try {
        await deleteNotification(user.uid, notification.id);
      } catch (err) {
        console.error('Delete failed:', err.message);
      }
    }, 500); // match CSS transition duration
  };

  const handleMarkRead = async () => {
    if (!notification.read) {
      await markNotificationAsRead(user.uid, notification.id);
    }
  };

  const getIcon = () => {
    switch (notification.type) {
      case 'debate_invite': return <HiChatBubbleBottomCenterText />;
      case 'friend_request': return <HiUserGroup />;
      case 'coins_received': return <HiCurrencyDollar />;
      case 'system': return <HiExclamationTriangle />;
      default: return <HiBell />;
    }
  };

  return (
    <div className={`${styles.card} ${notification.read ? styles.read : styles.unread} ${isDeleting ? styles.fadeOut : ''}`}>
      <Button className={styles.deleteBtn} onClick={handleDelete}>
        <HiXMark size={20} />
      </Button>
      <div className={styles.icon}>{getIcon()}</div>
      <div className={styles.content}>
        <div className={styles.title}>{notification.title}</div>
        <div className={styles.body}>{notification.body}</div>
        <div className={styles.time}>{new Date(notification.timestamp.toDate()).toLocaleString()}</div>
      </div>
      <div className={styles.actions}>
        <Button className={styles.markBtn} onClick={handleMarkRead}>{t('notifications.markread')}</Button>
        {notification.link && <a className={styles.linkBtn} href={notification.link}>Open</a>}
      </div>
    </div>
  );
}
